import React from 'react';
import R from 'ramda';
import injectSheet from 'react-jss';

import TextDiff from './text-dff';
import { LocPolicyDiff, BillingDiff, InsuranceDiff, CheckInCheckOutDiff } from './policyNotes-elements';

const styles = {
  typeContainer: {
    marginTop: '32px',
  },
  subHeader: {
    fontSize: '24px',
    fontWeight: 400,
    marginTop: '4px',
    paddingBottom: '12px',
    borderBottom: '1px solid #e6e9ec',
  },
  singleDiffContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  lhsContainer: {
    width: '45%',
    padding: '16px 4px',
  },
  rhsContainer: {
    marginLeft: '5%',
    width: '45%',
    padding: '16px 4px',
  },
};
const propTypes = {
  diffBlock: React.PropTypes.object,
  classes: React.PropTypes.object,
  label: React.PropTypes.string,
  type: React.PropTypes.string,
};
class PoliciesNotesDiffing extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { diffBlock, classes, label, type } = this.props;
    const {
      singleDiffContainer,
      lhsContainer,
      rhsContainer,
      typeContainer,
      subHeader,
    } = classes;
    if (type !== 'checkInCheckOut') {
      return (
        <div id={`policyNotes${type}`} className={typeContainer}>
          <div className={subHeader}> {label}</div>
          {
            R.keys(diffBlock).map((subType) => {
              const lhsData = R.path([subType, 'originalData', 'lhs'], diffBlock);
              const rhsData = R.path([subType, 'originalData', 'rhs'], diffBlock);
              const diffData = R.path([subType, 'diff'], diffBlock);
              const isString = R.is(String, lhsData) || R.is(String, rhsData);
              return (
                <div key={subType}>
                  <div style={{ fontSize: '16px', margin: '16px 0', fontWeight: 'bold' }}>{R.path([subType, 'label'], diffBlock)}</div>
                  <div className={singleDiffContainer}>
                    <div className={lhsContainer}>
                      {
                        R.call(R.cond([
                          [() => isString, R.always(<TextDiff isLeft {...diffData[0]}/>)],
                          [() => type === 'policies', R.always(
                            <LocPolicyDiff isLeft policyType={subType} {...diffBlock[subType]}/>
                          )],
                          [() => subType === 'billing', R.always(<BillingDiff isLeft {...diffBlock[subType]}/>)],
                          [() => subType === 'insurance', R.always(<InsuranceDiff isLeft {...diffBlock[subType]}/>)],
                        ]))
                      }
                    </div>
                    <div className={rhsContainer}>
                      {
                        R.call(R.cond([
                          [() => isString, R.always(<TextDiff isLeft={false} {...diffData[0]}/>)],
                          [() => type === 'policies', R.always(
                            <LocPolicyDiff isLeft={false} policyType={subType} {...diffBlock[subType]}/>
                          )],
                          [() => subType === 'billing', R.always(<BillingDiff isLeft={false} {...diffBlock[subType]}/>)],
                          [() => subType === 'insurance', R.always(<InsuranceDiff isLeft={false} {...diffBlock[subType]}/>)],
                        ]))
                      }
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      );
    }
    return (
      <section id={`policyNotes${type}`} className={typeContainer}>
        <div className={subHeader}> {label}</div>
        <div className={singleDiffContainer}>
          <div className={lhsContainer}>
            <CheckInCheckOutDiff isLeft {...diffBlock}/>
          </div>
          <div className={rhsContainer}>
            <CheckInCheckOutDiff isLeft={false} {...diffBlock}/>
          </div>
        </div>
      </section>
    )
  }
}
PoliciesNotesDiffing.propTypes = propTypes;
export default injectSheet(styles)(PoliciesNotesDiffing);





// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/policyNotes-content.jsx